function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.09 12.553a.675.675 0 01.91.63l-.01.106a.68.68 0 01-.45.53 2.327 2.327 0 102.739 3.457.637.637 0 01.538-.273l.105.009a.672.672 0 01.441 1.048 3.667 3.667 0 11-4.273-5.507zM12 8.667a1 1 0 011 1v.833c0 .092.075.167.167.167h2.166a1 1 0 110 2h-2.166a.167.167 0 00-.167.166v.834c0 .184.15.333.333.333H15a2.32 2.32 0 011.978 1.09l1.533 2.373a1 1 0 01-.847 1.534l-.128-.008a1 1 0 01-.72-.459l-1.533-2.373A.333.333 0 0015 16h-3a1 1 0 01-1-1V9.667a1 1 0 011-1zm0-4.334a1.667 1.667 0 110 3.334 1.667 1.667 0 010-3.334z"
});

function SvgWheelchairsAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgWheelchairsAvailable;